<!-- 由 suu 创建于 2025-07-29 星期二 -->
<template>
  <div class="ShopListItem">
    <img
      class="shop-item-img"
      :src="shopInfo.images + '?x-oss-process=image/resize,m_lfit,w_375'"
      alt=""
    />
    <div class="shop-item-info">
      <div class="info-title">{{ shopInfo.name }}</div>
      <div class="info-row info-address">
        <i class="iconfont icon-dingwei-shixin"></i>
        <span class="address-text">{{ shopInfo.address }}</span>
      </div>
      <div class="info-row info-locaiton">
        <i class="iconfont icon-daohang"></i>
        <span>距离您 {{ formatDistance(shopInfo.distance) }}</span>
        <div class="location-right">
          <template v-if="shopInfo.is_go">
            <i class="iconfont icon-gou"></i>最近去过
          </template>
          <template v-else-if="shopInfo.is_near">距离最近</template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopListItem',

  components: {},

  props: {
    shopIndex: {
      type: Number,
      default: 0
    },
    shopInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 打开导航
    // onOpenMap() {
    //   this.$betterwe.jumpRoute(
    //     `/mapLauncher?latitude=${parseFloat(
    //       this.shopInfo.lat
    //     )}&longitude=${parseFloat(this.shopInfo.lon)}&title=${
    //       this.shopInfo.name
    //     }`
    //   )
    // },
    // 计算距离
    formatDistance(val) {
      if (!val) {
        return '未知'
      }
      return Number(val) < 1000
        ? String(val).split('.')[0] + 'm'
        : (Number(val) / 1000).toFixed(1) + 'km'
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ShopListItem {
  width: 100%;
  box-sizing: border-box;
  &:not(:last-child) {
    margin-bottom: 24px;
  }
  display: flex;
  // align-items: center;
  .shop-item-img {
    width: 128px;
    height: 72px;
    object-fit: cover;
    border-radius: 6px;
  }
  .shop-item-info {
    flex: 1;
    margin-left: 10px;
    .info-title {
      font-weight: 600;
      font-size: 14px;
      color: #050b27;
      line-height: 20px;
    }
    .info-row {
      display: flex;
      // align-items: baseline;
      word-break: break-all;
      .iconfont {
        color: #050b27;
        font-size: 11px;
        font-weight: 600;
        margin-right: 5px;
        // margin-top: -1px;
      }
      &.info-address {
        margin-top: 4px;
        font-size: 10px;
        color: #050b27;
        line-height: 15px;
        .address-text {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      &.info-locaiton {
        margin-top: 6px;
        font-size: 10px;
        color: rgba($color: #050b27, $alpha: 0.5);
        line-height: 14px;
        .location-right {
          flex: 1;
          margin-left: 20px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          color: #050b27;
          .icon-gou {
            font-size: 12px;
            font-weight: 600;
            color: #ff2270;
            margin-right: 3px;
          }
        }
      }
    }
  }
}
</style>
